import { __read, __assign } from 'tslib';
import * as React from 'react';
import { useIconCardSectionContext } from '../IconCardSectionContext.esm.js';
import classNames from 'classnames';
import { ImageOrIcon } from '../../../common/ImageOrIcon/ImageOrIcon.esm.js';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import { useAnalyticsEvents } from '@invitae/nucleobase-analytics';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './IconCardSectionItem.module.esm.js';

var IconCardSectionItem = function (_a) {
    var _b, _c, _d, _e;
    var _f, _g, _h;
    var id = _a.id, _j = _a.fields, heading = _j.heading, body = _j.body, link = _j.link, image = _j.image, icon = _j.icon, cardLinkLabel = _j.cardLinkLabel;
    var _k = __read(React.useState(true), 2), isLoading = _k[0], setIsLoading = _k[1];
    var noMedia = !image && !icon;
    var cardSize = useIconCardSectionContext().cardSize;
    var isMiniCard = cardSize === 'mini';
    var analyticsProps = useAnalyticsEvents({ analyticsEvents: (_f = link.fields) === null || _f === void 0 ? void 0 : _f.analyticsEvents });
    if (!link.fields) {
        // eslint-disable-next-line no-console
        console.warn("[IconCardSectionItem] - Could not find fields for link id: ".concat(id));
        return null;
    }
    var handleLinkLoad = function () {
        setIsLoading(false);
    };
    var ariaLabel = "Get insights on ".concat(heading, " that can improve diagnosis, prognosis and patient care");
    var rootElementProps = __assign({ 'aria-label': ariaLabel }, analyticsProps);
    return (React.createElement("li", { className: classNames(styles.root, (_b = {}, _b[styles.rootMini] = isMiniCard, _b)) },
        React.createElement(BaseNucleobaseComponent, { classes: { root: classNames(styles.wrapper, (_c = {}, _c[styles.mini] = isMiniCard, _c)) }, onLoad: handleLinkLoad, rootElementProps: rootElementProps, source: (_g = link.fields) === null || _g === void 0 ? void 0 : _g.linkScheme }, !isLoading && (React.createElement(React.Fragment, null,
            (image || icon) && link.fields && (React.createElement("div", { className: styles.media },
                React.createElement(ImageOrIcon, { icon: icon, image: (_h = image === null || image === void 0 ? void 0 : image.fields) === null || _h === void 0 ? void 0 : _h.asset }))),
            React.createElement("div", { className: classNames(styles.text, (_d = {},
                    _d[styles.textWithoutMedia] = noMedia,
                    _d)) }, link.fields && (React.createElement("div", { className: styles.link },
                React.createElement("div", { className: classNames(styles.headingAndText, (_e = {},
                        _e[styles.headingAndTextWithoutMedia] = noMedia,
                        _e)) },
                    React.createElement(NvMarkdownInline, { className: styles.heading, element: "h3", elementWrapper: NvHeading, level: 4 }, heading),
                    body && React.createElement(NvMarkdown, { className: styles.body }, body),
                    cardLinkLabel && !isMiniCard && React.createElement("span", { className: styles.cardLinkLabel }, cardLinkLabel))))))))));
};

export { IconCardSectionItem as default };
//# sourceMappingURL=IconCardSectionItem.esm.js.map
